module.exports = __webpack_public_path__ + "static/media/image-graphic.e1cdffe8.svg";